"use client";
interface AdditionalFeaturesProps {
	additionalFeatures?: string[];
}

export function AdditionalFeatures({ additionalFeatures }: AdditionalFeaturesProps) {
	if (!additionalFeatures?.length) return null;

	return (
		<div className="py-1.5 px-2 space-y-2">
			{additionalFeatures.map((feature, index) => (
				<div key={index} className="text-sm text-gray-900">
					{feature}
				</div>
			))}
		</div>
	);
}
